import { useState, useEffect } from 'react';

class LoaderState {
  stateHandler: any | null;
  registered = false;
  // counter = 0;

  setEffect(handler: ((status: boolean) => void) | null) {
    this.stateHandler = handler;
    this.registered = true;
    // console.log('LOADER EFFECT REGISTERED..');
  }

  startLoader() {
    if (!this.registered) {
      setTimeout(() => {
        // this.counter++;
        // console.log('loader timeout counter', this.counter);
        this.startLoader();
      }, 800);
    } else {
      console.log('STARTING LOADER');
      this.stateHandler && this.stateHandler(true);
    }
  }

  stopLoader() {
    if (!this.registered) {
      setTimeout(() => {
        this.stopLoader();
      }, 2000);
    } else {
      this.stateHandler && this.stateHandler(false);
    }
  }
}

export const LoaderService = new LoaderState();

export const useLoader = function useLoaderEffect() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log('REGISTERING LOADER EFFECT..');
    LoaderService.setEffect((loading: boolean) => {
      // console.log('LOADING', loading);
      setIsLoading(loading);
    });
    return () => {
      // Cleaninig Effect...
      // console.log('Cleaninig useLoader Effect...');
      LoaderService.setEffect(null);
    };
  });
  return isLoading;
};
